import LandProvider from './LandProvider.container'
export default LandProvider
